<!--
 * @Author: 李明明
 * @Date: 2022-07-28 14:42:29
 * @LastEditTime: 2024-04-23 10:05:04
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/components/public/aside.vue
 * 代码版权方：'政府采购信息网'
-->
<template>
  <div class="aside_wrap">
    <el-menu
      ref="menu"
      class="el-menu-vertical-demo"
      background-color="#f2f7f7"
      :default-active="$route.path"
      active-text-color="#ffffff"
    >
      <template v-for="(item, index) in asideData" :key="index">
        <el-menu-item :index="item.link" @click="menuChangeRouter(item)">
          <i class="iconfont" :class="item.icon"></i>
          <span>{{ item.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script setup>
import { reactive } from "@vue/reactivity";
import { useRouter } from "vue-router";

const Router = useRouter();
let menuChangeRouter = (row) => {
  // 路由跳转方式
  Router.push({ path: row.link });
};

let asideData = [];
if (localStorage.getItem("hasOtherCourse") == 0) {
  asideData = [
    {
      name: "首页",
      icon: "iconshouye",
      link: "/",
    },
    {
      name: "我的课程",
      icon: "iconwodekecheng",
      link: "/course",
    },
    {
      name: "模拟考试",
      icon: "iconkaoshi1",
      link: "/exam_list",
    },
    {
      name: "模拟成绩查询",
      icon: "iconchaxun2",
      link: "/result_list",
    },
    {
      name: "学员培训记录",
      icon: "iconxinxi",
      link: "/train_info",
    },
    // {
    //   name: "账号报名记录",
    //   icon: "iconxinxi",
    //   link: "/student_management",
    // },
    {
      name: "我的订单",
      icon: "iconwodedingdan",
      link: "/order",
    },
  ];
} else {
  asideData = [
    {
      name: "首页",
      icon: "iconshouye",
      link: "/",
    },
    {
      name: "我的课程",
      icon: "iconwodekecheng",
      link: "/course",
    },
    {
      name: "我的考试",
      icon: "iconkaoshi1",
      link: "/exam_list",
    },
    {
      name: "成绩查询",
      icon: "iconchaxun2",
      link: "/result_list",
    },
    {
      name: "我的证书",
      icon: "iconwodezhengshu",
      link: "/zs",
    },
    {
      name: "学员培训记录",
      icon: "iconxinxi",
      link: "/train_info",
    },
    // {
    //   name: "账号报名记录",
    //   icon: "iconxinxi",
    //   link: "/student_management",
    // },
    {
      name: "我的订单",
      icon: "iconwodedingdan",
      link: "/order",
    },
  ];
}
</script>

<style lang="scss" scoped>
.aside_wrap {
  height: 100%;
  background: #f2f7f7;
  overflow: auto;
  position: relative;

  .is-active {
    background: #7a818b !important;
  }

  li {
    font-weight: 900;

    i {
      margin-right: 14px;
    }
  }

  .service_wrap {
    position: absolute;
    bottom: 0;

    .service {
      display: block;
      text-align: center;
      width: 200px;
      cursor: pointer;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.35);

      p {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 50px;
        letter-spacing: 1px;
        color: #68717c;
      }

      i {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: 900;
        font-stretch: normal;
        letter-spacing: 3px;
        color: #d81e06;
      }

      span {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: 900;
        font-stretch: normal;
        letter-spacing: 3px;
        color: #68727e;
        line-height: 58px;
        color: #68717c;
      }

      &:hover {
        ~ .service_pic {
          display: block;
        }
      }
    }

    .service_pic {
      display: none;
      position: absolute;
      bottom: 114px;
      text-align: center;
      width: 200px;
      cursor: pointer;
      background: #ffffff;
      z-index: 999;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.35);
    }
  }

  .side_footer {
    width: 200px;
    height: 60px;
    background: #418ec6;
    position: absolute;
    bottom: 0;
    text-align: center;

    p {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 56px;
      letter-spacing: 1px;
      color: #ffffff;
      margin-bottom: 0;
    }
  }
}
</style>
